import { IAppState } from '../../../../common/state';
import { IQuickLinksTab } from '../../../../types/quickLinks';
import { isArrayWithItems } from '../../../../utils';

export function getQuickLinksTabs(state: IAppState): IQuickLinksTab[] {
  const tabs = state.results.quickLinks;

  if (!isArrayWithItems<IQuickLinksTab>(tabs)) {
    return [];
  }

  return tabs.filter(tab => isArrayWithItems(tab.links));
}
